import React from 'react';
import header from '../Styles/header.jpg';
import shopBtn from '../Styles/shop.png';
import { Link } from "react-router-dom";
import craft from '../Styles/craft1.jpg';
import clothing from '../Styles/clothing.png';
import jacket from '../Styles/custom-jacket.jpg';
import artLogo from '../Styles/art2.png';
import littleBox from '../Styles/littlebox.jpg';
import '../Styles/Hero.css';

export default function Hero() {
  return (
    <div className='container-fluid text-center'>
        <div className='card'>
        <div className='header-img img-fluid'>
         <img src={header} className='img-top img-fluid ' alt='header-img'/>
        <div className="card-img-overlay">
        <div className="card-title text-start">Welcome 
        <div className="intro-card-text col-5">to Marshmallow Moon
        </div>
        </div>
            <div className='inspired col-6 d-flex align-items-center ms-5'>
               Designed by us. <strong className='ms-2'> Inspired by You.</strong>
        </div>
        </div>
        </div>
        </div>
        <h3 className="shop-collection text-center">Shop our collection of hand crafted products made with love. We offer custom work as unique as you. 
        </h3>
        <div className="container-fluid btn-grid text-center py-4">
             <div className="row row-cols-3 gx-5 justifiy-content-evenly">
             <div className="col">
                <div className='p-2'>
                <img src={littleBox} className='rounded img-fluid'  alt='little box img'/>
                </div>
             </div>
             <div className="col align-self-center">
                <Link to='Jewerly' className='center-grid justifiy-content-center'>
                 <img src={shopBtn} className='shopBtn img-fluid' height={416} alt='shopBtn' />
                    
                </Link>
             </div>
             <div className="col align-self-center">
                <div className='p-2'>
                    <img src={craft} className='rounded img-fluid' height={416} alt='craft img' />
                    </div>
             </div>
             <div className="col align-self-center">
             <Link to='Clothing' className='center-grid justifiy-content-center'>
                    <img src={clothing} className='rounded img-fluid clothingBtn' alt='clothing img' />
               </Link>
             </div>
             <div className="col align-self-center">
                <div className='p-2'>
                    <img src={jacket} className='rounded img-fluid jacket'  alt='jacket craft'  />
                </div>
             </div>
             <div className="col align-self-center">
                <Link to='ArtProducts' className='center-grid justifiy-content-center'>
                  <img src={artLogo} className='rounded img-fluid artBtn' alt='art logo'   />
                </Link>
             </div>
         </div>
         
        </div>
      
    </div>
  )
}




